import { HORIZONTAL_DEFAULT_POINTER_POSITION, POINTER, POINTER_POSITION, VERTICAL_DEFAULT_POINTER_POSITION, } from '../constants';
export const getPointerPosition = ({ pointer, top, left }) => {
    const positionStyles = {};
    switch (pointer) {
        case POINTER.top: {
            positionStyles.top = `${POINTER_POSITION}px`;
            positionStyles.left = `${left || VERTICAL_DEFAULT_POINTER_POSITION}%`;
            break;
        }
        case POINTER.left: {
            positionStyles.top = `${top || HORIZONTAL_DEFAULT_POINTER_POSITION}%`;
            positionStyles.left = `${POINTER_POSITION}px`;
            break;
        }
        case POINTER.right: {
            positionStyles.top = `${top || HORIZONTAL_DEFAULT_POINTER_POSITION}%`;
            positionStyles.right = `${POINTER_POSITION}px`;
            break;
        }
        case POINTER.bottom: {
            positionStyles.bottom = `${POINTER_POSITION}px`;
            positionStyles.left = `${left || VERTICAL_DEFAULT_POINTER_POSITION}%`;
            break;
        }
        default: {
            positionStyles.top = `${POINTER_POSITION}px`;
            positionStyles.left = `${left || VERTICAL_DEFAULT_POINTER_POSITION}%`;
            break;
        }
    }
    return positionStyles;
};
export const getPointerShape = ({ theme, pointer, }) => {
    const { radiusNone, radius20, } = theme.borders;
    switch (pointer) {
        case POINTER.top: {
            return {
                clipPath: 'polygon(0% 0%, 100% 100%, 100% 0%)',
                transform: 'rotate(-45deg)',
                borderRadius: `${radiusNone} ${radius20} ${radiusNone} ${radiusNone}`,
            };
        }
        case POINTER.left: {
            return {
                clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
                transform: 'rotate(45deg)',
                borderRadius: `${radiusNone} ${radiusNone} ${radiusNone} ${radius20}`,
            };
        }
        case POINTER.right: {
            return {
                clipPath: 'polygon(0% 0%, 100% 100%, 100% 0%)',
                transform: 'rotate(45deg)',
                borderRadius: `${radiusNone} ${radius20} ${radiusNone} ${radiusNone}`,
            };
        }
        case POINTER.bottom: {
            return {
                clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
                transform: 'rotate(-45deg)',
                borderRadius: `${radiusNone} ${radiusNone} ${radiusNone} ${radius20}`,
            };
        }
        default: {
            return {
                clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
                transform: 'rotate(-45deg)',
                borderRadius: `${radiusNone} ${radiusNone} ${radiusNone} ${radius20}`,
            };
        }
    }
};
